(() => {
  if (!document.querySelector('media-gallery')) return;
  const seen = new WeakSet();
  const boundsCache = new WeakMap();
  const observer = new ResizeObserver(entries => {
    for (const entry of entries) place(entry.target);
  });
  function fallback(width, height) {
    if (width < 1150 && height < 1600 && width > 1000) return { left: .115, top: .118, right: .885, bottom: .872 };
    return { left: .115, top: .115, right: .887, bottom: .87 };
  }
  function frameBounds(img) {
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const width = Math.min(360, naturalWidth);
    const height = Math.round(naturalHeight * width / naturalWidth);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(img, 0, 0, width, height);
    try {
      const data = context.getImageData(0, 0, width, height).data;
      const corner = (x, y) => data[(y * width + x) * 4 + 3];
      const transparent = [corner(0, 0), corner(width - 1, 0), corner(0, height - 1), corner(width - 1, height - 1)].filter(value => value < 80).length >= 2;
      let left = width, right = 0, top = height, bottom = 0;
      for (let y = 0; y < height; y += 2) {
        for (let x = 0; x < width; x += 2) {
          const i = (y * width + x) * 4;
          const visible = transparent
            ? data[i + 3] > 170
            : data[i] < 105 && data[i + 1] < 105 && data[i + 2] < 105;
          if (!visible) continue;
          left = Math.min(left, x);
          right = Math.max(right, x);
          top = Math.min(top, y);
          bottom = Math.max(bottom, y);
        }
      }
      if (right - left < width * .55 || bottom - top < height * .55 || right - left > width * .96) return fallback(naturalWidth, naturalHeight);
      return { left: left / width, top: top / height, right: (right + 2) / width, bottom: (bottom + 2) / height };
    } catch (_) {
      return fallback(naturalWidth, naturalHeight);
    }
  }
  function place(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    const parent = img.closest('.product-media');
    if (!parent) return;
    let overlay = parent.querySelector('.cultures-white-frame-preview');
    if (!overlay) {
      overlay = document.createElement('span');
      overlay.className = 'cultures-white-frame-preview';
      overlay.setAttribute('aria-hidden', 'true');
      parent.appendChild(overlay);
    }
    const source = img.currentSrc || img.src;
    const cached = boundsCache.get(img);
    const bounds = cached && cached.source === source ? cached.bounds : frameBounds(img);
    if (!cached || cached.source !== source) boundsCache.set(img, { source, bounds });
    const width = img.clientWidth;
    const height = img.clientHeight;
    const fit = getComputedStyle(img).objectFit;
    const scale = fit === 'cover'
      ? Math.max(width / img.naturalWidth, height / img.naturalHeight)
      : Math.min(width / img.naturalWidth, height / img.naturalHeight);
    const drawnWidth = img.naturalWidth * scale;
    const drawnHeight = img.naturalHeight * scale;
    const imageLeft = img.offsetLeft + (width - drawnWidth) / 2;
    const imageTop = img.offsetTop + (height - drawnHeight) / 2;
    const left = imageLeft + bounds.left * drawnWidth;
    const top = imageTop + bounds.top * drawnHeight;
    const outerWidth = (bounds.right - bounds.left) * drawnWidth;
    const outerHeight = (bounds.bottom - bounds.top) * drawnHeight;
    overlay.style.left = left + 'px';
    overlay.style.top = top + 'px';
    overlay.style.width = outerWidth + 'px';
    overlay.style.height = outerHeight + 'px';
    overlay.style.borderLeftWidth = outerWidth * .055 + 'px';
    overlay.style.borderRightWidth = outerWidth * .055 + 'px';
    overlay.style.borderTopWidth = outerWidth * .048 + 'px';
    overlay.style.borderBottomWidth = outerWidth * .058 + 'px';
  }
  function init() {
    document.querySelectorAll('media-gallery .product-media__image').forEach(img => {
      if (seen.has(img)) return;
      seen.add(img);
      img.dataset.culturesOriginalAlt = img.alt;
      img.addEventListener('load', () => place(img));
      observer.observe(img);
      if (img.complete) place(img);
    });
    syncAlt();
  }
  function syncAlt() {
    const white = document.body.classList.contains('cultures-frame-white-selected');
    document.querySelectorAll('media-gallery .product-media__image').forEach(img => {
      const original = img.dataset.culturesOriginalAlt || img.alt;
      img.alt = white ? original.replace(/cadre noir/ig, 'cadre blanc') : original;
    });
  }
  function sync() {
    const white = [...document.querySelectorAll('input[data-option-name="Finition"]:checked')].some(input => /cadre blanc/i.test(input.value));
    document.body.classList.toggle('cultures-frame-white-selected', white);
    syncAlt();
  }
  document.addEventListener('change', event => {
    if (event.target.matches('input[data-option-name="Finition"]')) requestAnimationFrame(sync);
  });
  const mutations = new MutationObserver(() => init());
  mutations.observe(document.body, { childList: true, subtree: true });
  init();
  sync();
})();
